import { FaWhatsapp, FaXmark } from "react-icons/fa6";

export const ModalWraper = ({ isOpen, setIsOpen, title, icon, maxWidth, children }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 h-screen"
            style={{
                background: "rgba(0, 0, 0, 0.7)",
                backdropFilter: "blur(4px)",
            }}
            onClick={() => setIsOpen(false)}
        >
            <div
                className={`w-full ${maxWidth ?? "max-w-lg"} rounded-2xl overflow-visible shadow-2xl`}
                style={{
                    background: "rgba(15, 23, 42, 0.95)",
                    border: "1px solid rgba(51, 65, 85, 0.4)",
                    maxHeight: "90vh",        // ← BATAS TINGGI
                    display: "flex",            // ← FLEX CONTAINER
                    flexDirection: "column",    // ← KOLOM (atas-bawah)
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header — TIDAK scroll, tetap di atas */}
                <div
                    className="flex items-center justify-between px-6 py-4 flex-shrink-0"  // ← flex-shrink-0
                    style={{
                        borderBottom: "1px solid rgba(51, 65, 85, 0.3)",
                        background: "rgba(15, 23, 42, 0.8)",
                    }}
                >
                    <h3 className="text-lg font-bold text-gray-100 flex items-center gap-2">
                        {icon}
                        {title}
                    </h3>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="text-slate-400 hover:text-white transition-colors p-1"
                    >
                        <FaXmark className="text-xl" />
                    </button>
                </div>

                {/* Body — YANG SCROLL */}
                <div 
                    className="p-6 overflow-y-auto flex-1"  // ← overflow-y-auto + flex-1
                >
                    {children}
                </div>
            </div>
        </div>
    );
};